export enum UserConstants {
    USER_ME = 'USER/ME',
}
